import request from "../../Requests/requests";
import { loadWorkTime } from "../../store/WorkTimeStore/WorkTimeReducer";

export const addWorkTime = (payload) => {
    return async dispatch => {
        try {
            const response = await request.put('/Time/WorkTime/', { userId: localStorage.getItem('userID'), 
            time: payload.workTime})
            .then(() => dispatch(loadWorkTime(payload)))
            const data = response.data
            return data
        } catch (error) {
            return error
        }
    } 
}